(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ics-bom-review-matrix"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bom-review-matrix')) {
    customElements.define('bom-review-matrix', class extends HTMLElement {
      connectedCallback() {
        this.buttons = Array.from(this.querySelectorAll('[data-review-filter]'));
        this.rows = Array.from(this.querySelectorAll('[data-review-state]'));
        this.count = this.querySelector('[data-review-count]');
        this.buttons.forEach((button) => button.addEventListener('click', () => this.filter(button.dataset.reviewFilter)));
      }

      filter(state) {
        let visible = 0;
        this.buttons.forEach((button) => button.classList.toggle('is-active', button.dataset.reviewFilter === state));
        this.rows.forEach((row) => {
          const show = state === 'all' || row.dataset.reviewState === state;
          row.hidden = !show;
          if (show) visible += 1;
        });
        this.count.textContent = `${visible} ${visible === 1 ? 'review state' : 'review states'} shown`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ics-bom-rfq-form"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bom-rfq-form')) {
    customElements.define('bom-rfq-form', class extends HTMLElement {
      connectedCallback() {
        this.lines = this.querySelector('[data-bom-lines-field]');
        this.source = this.querySelector('[data-bom-source-field]');
        this.note = this.querySelector('[data-bom-sync-note]');
        this.syncFromStorage();
        window.addEventListener('ics:bom-updated', (event) => this.sync(event.detail));
      }

      syncFromStorage() {
        try {
          const stored = JSON.parse(sessionStorage.getItem(this.dataset.storageKey) || 'null');
          if (stored && Array.isArray(stored.rows)) this.sync(stored);
        } catch (error) {
          this.dataset.storageState = 'unavailable';
        }
      }

      sync(detail) {
        if (!detail || !Array.isArray(detail.rows) || !detail.rows.length) return;
        this.lines.value = detail.rows
          .map((row, index) => `${index + 1}. ${row.mpn} | ${row.manufacturer} | ${row.quantity} pcs`)
          .join('\n');
        this.source.value = detail.source || 'Prepared in BOM workspace';
        this.note.textContent = `${detail.rows.length} ${detail.rows.length === 1 ? 'line has' : 'lines have'} been carried into this request. You can edit them before submitting.`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ics-bom-workspace"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bom-workspace')) {
    customElements.define('bom-workspace', class extends HTMLElement {
      connectedCallback() {
        this.rows = [];
        this.storageKey = this.dataset.storageKey;
        this.tabs = Array.from(this.querySelectorAll('[data-bom-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-bom-panel]'));
        this.feedback = this.querySelector('[data-bom-feedback]');
        this.preview = this.querySelector('[data-bom-preview]');
        this.body = this.querySelector('[data-bom-body]');
        this.count = this.querySelector('[data-bom-count]');
        this.tabs.forEach((tab) => tab.addEventListener('click', () => this.activate(tab.dataset.bomTab)));
        this.querySelector('[data-bom-file]').addEventListener('change', (event) => this.readCsv(event));
        this.querySelector('[data-bom-parse]').addEventListener('click', () => this.parsePaste());
        this.querySelector('[data-bom-add]').addEventListener('click', () => this.addManual());
        this.querySelector('[data-bom-clear]').addEventListener('click', () => this.clearRows());
        this.querySelector('[data-bom-continue]').addEventListener('click', () => this.continueToForm());
        this.restoreRows();
        this.prefillFromUrl();
      }

      prefillFromUrl() {
        const params = new URLSearchParams(window.location.search);
        const part = (params.get('part') || '').trim();
        if (!part || this.rows.length) return;
        const manufacturer = (params.get('manufacturer') || '').trim();
        const mpn = this.querySelector('[data-bom-mpn]');
        const manufacturerInput = this.querySelector('[data-bom-manufacturer]');
        const quantity = this.querySelector('[data-bom-quantity]');
        if (!mpn || !quantity) return;
        this.activate('manual');
        mpn.value = part;
        if (manufacturerInput) manufacturerInput.value = manufacturer;
        quantity.value = '1';
        this.addManual();
      }

      activate(mode) {
        this.tabs.forEach((tab) => {
          const active = tab.dataset.bomTab === mode;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.bomPanel !== mode;
        });
      }

      readCsv(event) {
        const file = event.target.files[0];
        if (!file) return;
        this.showFeedback('loading', 'Reading your CSV', 'Checking line structure before the request is prepared.');
        const reader = new FileReader();
        reader.onload = () => {
          const parsed = this.parseText(String(reader.result || ''));
          if (parsed.length) {
            this.rows = parsed;
            this.persistRows(file.name);
            this.renderRows();
          } else {
            this.showFeedback('error', 'No usable BOM lines found', 'Include a manufacturer part number and quantity on each line, then try again.');
          }
        };
        reader.onerror = () => this.showFeedback('error', 'The CSV could not be read', 'Choose another CSV or paste the BOM lines into the workspace.');
        reader.readAsText(file);
      }

      parsePaste() {
        const value = this.querySelector('[data-bom-paste]').value;
        const parsed = this.parseText(value);
        if (!parsed.length) {
          this.showFeedback('error', 'No usable BOM lines found', 'Use one line per part with MPN, manufacturer and quantity.');
          return;
        }
        this.rows = parsed;
        this.persistRows('Pasted BOM lines');
        this.renderRows();
      }

      parseText(value) {
        const lines = value.split(/\r?\n/).map((line) => line.trim()).filter(Boolean);
        const rows = [];
        lines.forEach((line, index) => {
          const delimiter = line.includes('\t') ? '\t' : line.includes('|') ? '|' : ',';
          const cells = line.split(delimiter).map((cell) => cell.trim().replace(/^"|"$/g, ''));
          const first = (cells[0] || '').toLowerCase();
          if (index === 0 && (first.includes('part') || first === 'mpn')) return;
          const quantity = (cells[2] || '').replace(/[^\d.]/g, '');
          if (cells[0] && quantity && Number(quantity) > 0) {
            rows.push({ mpn: cells[0], manufacturer: cells[1] || 'Not specified', quantity: quantity });
          }
        });
        return rows.slice(0, 250);
      }

      addManual() {
        const mpn = this.querySelector('[data-bom-mpn]');
        const manufacturer = this.querySelector('[data-bom-manufacturer]');
        const quantity = this.querySelector('[data-bom-quantity]');
        if (!mpn.value.trim() || !quantity.value || Number(quantity.value) < 1) {
          this.showFeedback('error', 'Complete the required line fields', 'Add a manufacturer part number and a quantity greater than zero.');
          return;
        }
        this.rows.push({
          mpn: mpn.value.trim(),
          manufacturer: manufacturer.value.trim() || 'Not specified',
          quantity: quantity.value
        });
        mpn.value = '';
        manufacturer.value = '';
        quantity.value = '';
        this.persistRows('Manual BOM entry');
        this.renderRows();
        mpn.focus();
      }

      renderRows() {
        this.body.replaceChildren();
        this.rows.forEach((row) => {
          const tr = document.createElement('tr');
          [row.mpn, row.manufacturer, row.quantity].forEach((value) => {
            const td = document.createElement('td');
            td.textContent = value;
            tr.appendChild(td);
          });
          const stateCell = document.createElement('td');
          const state = document.createElement('span');
          state.className = 'ics-bom-workspace__state';
          state.textContent = 'Ready';
          stateCell.appendChild(state);
          tr.appendChild(stateCell);
          this.body.appendChild(tr);
        });
        this.count.textContent = `${this.rows.length} ${this.rows.length === 1 ? 'line' : 'lines'} ready`;
        this.feedback.hidden = true;
        this.preview.hidden = false;
      }

      showFeedback(state, title, text) {
        const symbols = { loading: '…', success: '✓', error: '!', empty: '○' };
        this.feedback.hidden = false;
        this.preview.hidden = true;
        this.feedback.innerHTML = '';
        const panel = document.createElement('div');
        panel.className = `ics-system-state ics-system-state--${state}`;
        panel.setAttribute('role', state === 'error' ? 'alert' : 'status');
        const indicator = document.createElement('span');
        indicator.className = 'ics-system-state__indicator';
        indicator.setAttribute('aria-hidden', 'true');
        indicator.textContent = symbols[state] || 'i';
        const content = document.createElement('div');
        const heading = document.createElement('h3');
        heading.className = 'ics-system-state__title';
        heading.textContent = title;
        const copy = document.createElement('p');
        copy.className = 'ics-system-state__text';
        copy.textContent = text;
        content.append(heading, copy);
        panel.append(indicator, content);
        this.feedback.appendChild(panel);
      }

      persistRows(source) {
        try {
          sessionStorage.setItem(this.storageKey, JSON.stringify({ source, rows: this.rows }));
        } catch (error) {
          this.dataset.storageState = 'unavailable';
        }
        window.dispatchEvent(new CustomEvent('ics:bom-updated', { detail: { source, rows: this.rows } }));
      }

      restoreRows() {
        try {
          const stored = JSON.parse(sessionStorage.getItem(this.storageKey) || 'null');
          if (stored && Array.isArray(stored.rows) && stored.rows.length) {
            this.rows = stored.rows;
            this.renderRows();
          }
        } catch (error) {
          this.rows = [];
        }
      }

      clearRows() {
        this.rows = [];
        try {
          sessionStorage.removeItem(this.storageKey);
        } catch (error) {
          this.dataset.storageState = 'unavailable';
        }
        this.body.replaceChildren();
        this.preview.hidden = true;
        this.showFeedback('empty', 'Your BOM workspace is ready', 'Upload a CSV, paste part lines or add a requirement manually.');
      }

      continueToForm() {
        this.persistRows('Prepared in BOM workspace');
        const form = document.getElementById('bom-rfq');
        if (form) {
          form.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          window.setTimeout(() => {
            const field = form.querySelector('[data-bom-lines-field]');
            if (field) field.focus();
          }, 450);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ics-eol-form"] && !Shopify.designMode) return;
  try {
    
  const enhanceEolForms = function (scope) {
    const root = scope && scope.querySelectorAll ? scope : document;
    const embeds = root.querySelectorAll('.ics-eol-request__app-form shopify-forms-embed');

    embeds.forEach(function (embed) {
      let attempts = 0;
      const applyTheme = function () {
        attempts += 1;
        if (!embed.shadowRoot) {
          if (attempts < 40) window.setTimeout(applyTheme, 250);
          return;
        }

        let style = embed.shadowRoot.getElementById('ics-eol-forms-theme');
        if (!style) {
          style = document.createElement('style');
          style.id = 'ics-eol-forms-theme';
          style.textContent = `
          :host {
            display: block !important;
            width: 100% !important;
            max-width: none !important;
            color: #101828 !important;
          }

          *, *::before, *::after {
            box-sizing: border-box;
          }

          form {
            width: 100% !important;
            max-width: none !important;
            margin: 0 !important;
          }

          .ics-eol-form-grid {
            display: grid !important;
            grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
            column-gap: 18px !important;
            row-gap: 16px !important;
            width: 100% !important;
            max-width: none !important;
          }

          .ics-eol-form-grid > * {
            min-width: 0 !important;
            width: 100% !important;
            max-width: none !important;
            margin: 0 !important;
          }

          .ics-eol-form-grid > .ics-eol-form-span-full {
            grid-column: 1 / -1 !important;
          }

          h1, h2, h3 {
            color: #101828 !important;
            letter-spacing: -0.025em !important;
            line-height: 1.16 !important;
            text-align: left !important;
          }

          p {
            color: #5b6b82 !important;
            line-height: 1.6 !important;
            text-align: left !important;
          }

          label {
            color: #26344a !important;
            font-size: 14px !important;
            font-weight: 650 !important;
          }

          input:not([type='checkbox']):not([type='radio']):not([type='file']),
          textarea,
          select {
            min-height: 52px !important;
            width: 100% !important;
            border: 1px solid #ccd4df !important;
            border-radius: 8px !important;
            background: #ffffff !important;
            color: #101828 !important;
            box-shadow: none !important;
          }

          textarea {
            min-height: 128px !important;
            resize: vertical !important;
          }

          input:not([type='checkbox']):not([type='radio']):not([type='file']):hover,
          textarea:hover,
          select:hover {
            border-color: #99aac1 !important;
          }

          input:not([type='checkbox']):not([type='radio']):not([type='file']):focus,
          textarea:focus,
          select:focus {
            border-color: #155eef !important;
            outline: 3px solid rgba(21, 94, 239, 0.16) !important;
            outline-offset: 0 !important;
          }

          button[type='submit'] {
            min-height: 54px !important;
            border-radius: 8px !important;
            background: #155eef !important;
            color: #ffffff !important;
            font-weight: 750 !important;
            letter-spacing: 0.01em !important;
            box-shadow: 0 10px 22px rgba(21, 94, 239, 0.2) !important;
          }

          button[type='submit']:hover {
            background: #0f4fd6 !important;
          }

          button[type='submit']:active {
            transform: translateY(1px) !important;
          }

          a {
            color: #155eef !important;
            text-underline-offset: 3px !important;
          }

          @media (max-width: 649px) {
            .ics-eol-form-grid {
              grid-template-columns: 1fr !important;
            }

            .ics-eol-form-grid > * {
              grid-column: 1 / -1 !important;
            }

            h1, h2, h3 {
              font-size: 26px !important;
            }
          }
        `;
          embed.shadowRoot.appendChild(style);
        }

        const form = embed.shadowRoot.querySelector('form');
        if (!form) {
          if (attempts < 40) window.setTimeout(applyTheme, 250);
          return;
        }

        let widthLayer = form;
        while (widthLayer && widthLayer !== embed.shadowRoot) {
          widthLayer.style.setProperty('width', '100%', 'important');
          widthLayer.style.setProperty('max-width', 'none', 'important');
          widthLayer.style.setProperty('margin-left', '0', 'important');
          widthLayer.style.setProperty('margin-right', '0', 'important');
          widthLayer = widthLayer.parentElement;
        }

        const controlSelector = "input:not([type='hidden']), textarea, select";
        const candidates = Array.from(form.querySelectorAll('*')).filter(function (element) {
          const fieldChildren = Array.from(element.children).filter(function (child) {
            return child.matches(controlSelector) || child.querySelector(controlSelector);
          });
          return fieldChildren.length >= 4;
        });

        let fieldGrid = null;
        let bestScore = -1;
        candidates.forEach(function (candidate) {
          const fieldChildren = Array.from(candidate.children).filter(function (child) {
            return child.matches(controlSelector) || child.querySelector(controlSelector);
          });
          const score = fieldChildren.length * 100 + candidate.querySelectorAll(controlSelector).length;
          if (score > bestScore) {
            bestScore = score;
            fieldGrid = candidate;
          }
        });

        if (fieldGrid) {
          fieldGrid.classList.add('ics-eol-form-grid');
          Array.from(fieldGrid.children).forEach(function (item) {
            const controls = item.matches(controlSelector)
              ? [item]
              : Array.from(item.querySelectorAll(controlSelector));
            if (!controls.length) return;

            const fieldText = [
              item.textContent || '',
              controls.map(function (control) {
                return [
                  control.getAttribute('name') || '',
                  control.getAttribute('placeholder') || '',
                  control.getAttribute('aria-label') || ''
                ].join(' ');
              }).join(' ')
            ].join(' ').toLowerCase();
            const hasLongControl = controls.some(function (control) {
              const type = (control.getAttribute('type') || '').toLowerCase();
              return control.tagName === 'TEXTAREA' || type === 'file';
            });
            const shouldSpan = hasLongControl ||
              controls.length > 2 ||
              /part number|quantit|requirement|additional|detail|comment|note|attachment|document/.test(fieldText);

            item.classList.toggle('ics-eol-form-span-full', shouldSpan);
          });
        }

        if (!embed.icsEolFormObserver) {
          const observer = new MutationObserver(function () {
            window.requestAnimationFrame(applyTheme);
          });
          observer.observe(embed.shadowRoot, { childList: true, subtree: true });
          embed.icsEolFormObserver = observer;
        }
      };

      applyTheme();
    });
  };

  document.addEventListener('DOMContentLoaded', function () {
    enhanceEolForms(document);

    const params = new URLSearchParams(window.location.search);
    const part = (params.get('part') || '').trim();
    if (!part) return;
    const field = document.getElementById('IcsEolParts');
    if (!field) return;
    field.value = part;
    const panel = field.closest('.ics-eol-request__panel');
    if (panel) {
      panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    enhanceEolForms(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300),
      );
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
